import '../global.js'
import 'slick-carousel'
import 'jquery-match-height'
// import '../plugins/fixed-block.js';
import 'sticky-sidebar-v2/dist/jquery.sticky-sidebar';
import 'slick-carousel/slick/slick.css';
import FabricSlider from "./FabricSlider";
import FabricOnScroll from "./FabricOnScroll";
import FabricHeroWave from "./FabricHeroWave";

export const Share = () => {
    var Config = {
        Link: "a.share-popup",
        Width: 500,
        Height: 500
    };

    $(Config.Link).on('click', function(e){

        e.preventDefault();

        var
            px = Math.floor(((screen.availWidth || 1024) - Config.Width) / 2),
            py = Math.floor(((screen.availHeight || 700) - Config.Height) / 2);

        var popup = window.open($(this).attr('href'), "social", 
            "width="+Config.Width+",height="+Config.Height+
            ",left="+px+",top="+py+
            ",location=0,menubar=0,toolbar=0,status=0,scrollbars=1,resizable=1");
        if (popup) {
            popup.focus();
            if (e.preventDefault) e.preventDefault();
            e.returnValue = false;
        }

    });
}

export const fixedHeader = () => {
    var offset = 0;
    var item = jQuery('#header');

    jQuery(window).scroll(function(){
     if( $(this).scrollTop() > offset ) {
        item.addClass('fixed-position');
     } else {
        item.removeClass('fixed-position');
     }
    });
}

export const MobileNav = () => {
    var navopener = $('.nav-opener'),
    navwrap   = $('.nav'),
    links     = navwrap.find('a'),
    navactive = 'nav-active';

    navopener.click(function() {
        $('body').toggleClass(navactive);
    });

    $('.nav li').each(function() {
        var item = $(this);
        var drop = item.find('ul');
        var link = item.find('a').eq(0);
        if(drop.length) {
            item.addClass('hasdrop');
            if(link.length) {
                if (link[0].href.includes('#')) {
                    link.addClass('hasdrop-a').attr({'data-more': '', 'data-outside': ''});
                } else {
                    link.after('<span class="hasdrop-a" data-more data-outside></span>');
                }
            }
        }
    });

    links.click(function() {
        $(this).hasClass('hasdrop-a') ? false : $('body').removeClass(navactive);
    });

    $('html').on('click touchstart pointerdown MSPointerDown', function(e) {
        var target = $(e.target);
        if(!target.closest(navopener).length && !target.closest(navwrap).length) {
            $('body').removeClass(navactive);
        }
    });
}

export const OpenClose = () => {
    $('[data-more]').next().hide();
    $('[data-more].active').next().show();

    $('[data-more]').click(function(e) {
        e.preventDefault();
        $(this).hasClass('active') ? $(this).removeClass('active').next().slideUp(200) : $(this).addClass('active').next().slideToggle(200);

        if($(this).closest('[data-accordion]').length) {
            $(this).parent().siblings().find('[data-more]').removeClass('active');
            $(this).parent().siblings().find('[data-more]').next().slideUp(200);
        }
    });

    $('[data-toggle-active]').click(function (e) {
        e.preventDefault();
        $(this).hasClass('active') ? $(this).removeClass('active') : $(this).addClass('active');
    });

    $('[data-outside]').next().find('a:not(.hasdrop-a):not([data-more])').click(function() {
        $('[data-outside]').removeClass('active');
        $('[data-outside]:not([data-toggle-active])').next().slideUp(200);
    });

    $('[data-outside]').click(function(e) {
        $('[data-outside]').not(this).removeClass('active');
        $('[data-outside]:not([data-toggle-active])').not(this).next().slideUp(200);
    });

    $('html').on('click touchstart pointerdown MSPointerDown', function(e) {
        var target = $(e.target);

        if(!(target.closest('[data-outside]').length) && !(target.closest('[data-outside] + *').length)) {
            setTimeout (function() {
                $('[data-outside]').removeClass('active');
                $('[data-outside]:not([data-toggle-active])').next().slideUp(200);
            }, 200)
        }

        if(!(target.closest('[data-outside-1]').length) && !(target.closest('[data-outside-1] + *').length)) {
            setTimeout (function() {
                $('[data-outside-1]').removeClass('active').next().slideUp(200);
            }, 200)
        }
    });
}

export const CustomSelect = () => {
    jQuery('[data-select]').each(function(){
        var item = jQuery(this),
        selectDrop = item.next(),
        linkItems = selectDrop.find('a');

        item.attr({'data-outside': '', 'data-more': ''})

        linkItems.on('click', function(e) {
            e.preventDefault();
            item.text(jQuery(this).text());
            selectDrop.slideUp(200);
            item.removeClass('active').addClass('selected');

            selectDrop.find('li').removeClass('active');
            jQuery(this).parent().addClass('active');
        });

        if(selectDrop.children().hasClass('active')) {
            item
            .text(jQuery(this).next().find('.active a').text())
            .addClass('selected');
        }
    });
}

export const Tabs = () => {
    $('[data-tab]').click(function(e){
        e.preventDefault();
        var tab_id = $(this).attr('data-tab');

        $(this).parent().siblings().find('[data-tab]').removeClass('active');
        $("#"+tab_id).siblings().removeClass('active');

        $(this).addClass('active');
        $("#"+tab_id).addClass('active');
    })
    $('#'+$('[data-tab].active').data('tab')).addClass('active');
}

export const SlickSlider = () => {

    jQuery('.member-slider').slick({
        dots: false,
        prevArrow: '<button class="icon-prev slick-prev"></button>',
        nextArrow: '<button class="icon-next slick-next"></button>',
        arrows: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        rows: 0,
        autoplay: true,
        responsive: [
        {
            breakpoint: 1023,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 640,
            settings: {
                slidesToShow: 1,
                slidesToScroll:  1
            }
        }
        ]
    });

    jQuery('.slider , .customer-slider , .testimonials-slider , .testimonials-slider-01, .column-slider, .related-slider').on('init', function(event, slick){
        setSlideCount(slick);
    });

    jQuery('.slider , .customer-slider , .testimonials-slider , .testimonials-slider-01, .column-slider, .related-slider').on('afterChange', function(event, slick){
        setSlideCount(slick);
    });

    jQuery('.slider').each(function(){
        var slider = jQuery(this);

        if (!slider.hasClass('slick-initialized')) {
            dots: false,
            slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            rows: 0,
            autoplay: true,
            prevArrow: '<button class="icon-prev slick-prev"></button>',
            nextArrow: '<button class="icon-next slick-next"></button>',
        });
        }
    });

    jQuery('.customer-slider').each(function(){
        var slider = jQuery(this);
        var arrowsHolder = slider.closest('.customer-slider-hold').find('.slider-nav');

        if (!slider.hasClass('slick-initialized')) {
            dots: false,
            slider.slick({
            slidesToShow: 1,
            rows: 0,
            variableWidth: true,
            infinite: true,
            appendArrows: arrowsHolder,
            prevArrow: '<button class="icon-prev slick-prev"></button>',
            nextArrow: '<button class="icon-next slick-next"></button>',
        });
        }
    });

    function setSlideCount(slickGallery) {
        var slideCount = slickGallery.$slider.closest('.slider-holder, .customer-slider-hold , .testimonials, .column-slider-wrap, .related-slider-wrap').find('.slideCount');

        slideCount.text('0'+(slickGallery.currentSlide + 1) + ' / ' +  '0'+slickGallery.slideCount);
    }

    jQuery('.main-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        autoplay: true,
        prevArrow: '<button class="icon-prev slick-prev"></button>',
        nextArrow: '<button class="icon-next slick-next"></button>',

    });

    jQuery('.tab-content-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        asNavFor: '.navs-slider',
        rows: 0,
        fade: true
    });

    jQuery('.news-slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        asNavFor: '.small-slider',
        fade: true,
        adaptiveHeight: true,
    });

    jQuery('.navs-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '.tab-content-slider',
        dots: false,
        focusOnSelect: true,
        arrows: false,
        fade: true,
        rows: 0,
        responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
            }
        }
        ]
    });

	jQuery('.partners .partners-slider, .partners-slider-wrap.alt .partners-list').each(function() {
		var slider = jQuery(this);

		if (!slider.hasClass('slick-initialized')) {
			slider.slick({
				slidesToShow: 5,
				slidesToScroll: 1,
				rows: 0,
				autoplay: true,
				arrows: false,
				autoplaySpeed: 0,
				speed: 4000,
				pauseOnHover: false,
				cssEase: 'linear',
				infinite: true,
				responsive: [
					{
						breakpoint: 1024,
						settings: {
							slidesToShow: 4,
						}
					},
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 3,
						}
					},
					{
						breakpoint: 480,
						settings: {
							slidesToShow: 2,
						}
					}
				]
			});
		}
	});

    jQuery('.features-with-logos-slider .partners-list').each(function() {
		var slider = jQuery(this);

		if (!slider.hasClass('slick-initialized')) {
			slider.slick({
				slidesToShow: 6,
				slidesToScroll: 1,
				rows: 0,
				autoplay: true,
				arrows: false,
				autoplaySpeed: 0,
				speed: 4000,
				pauseOnHover: false,
				cssEase: 'linear',
				infinite: true,
				responsive: [
					{
						breakpoint: 1024,
						settings: {
							slidesToShow: 4,
						}
					},
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 3,
						}
					},
					{
						breakpoint: 480,
						settings: {
							slidesToShow: 2,
						}
					}
				]
			});
		}
	});


    jQuery('.testimonials-slider').each(function(){
        var slider = jQuery(this);
        var arrowsHolder = slider.closest('.testimonials').find('.slider-nav');

        if (!slider.hasClass('slick-initialized')) {
            dots: false,
            slider.slick({
                prevArrow: '<button class="icon-prev slick-prev"></button>',
                nextArrow: '<button class="icon-next slick-next"></button>',
                arrows: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                rows: 0,
                autoplay: true,
                appendArrows: arrowsHolder,
                responsive: [
                {
                    breakpoint: 1023,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll:  1
                    }
                }
                ]
            });
        }
    });

    jQuery('.testimonials-slider-01').each(function(){
        var slider = jQuery(this);
        var arrowsHolder = slider.closest('.testimonials').find('.slider-nav');

        if (!slider.hasClass('slick-initialized')) {
            dots: false,
            slider.slick({
                prevArrow: '<button class="icon-prev slick-prev"></button>',
                nextArrow: '<button class="icon-next slick-next"></button>',
                arrows: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                rows: 0,
                autoplay: true,
                appendArrows: arrowsHolder,
                adaptiveHeight: true,
                responsive: [
                {
                    breakpoint: 1023,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll:  1
                    }
                }
                ]
            });
        }
    });

    jQuery('.column-slider').each(function(){
        var slider = jQuery(this);
        var arrowsHolder = slider.closest('.column-slider-wrap').find('.slider-nav');

        if (!slider.hasClass('slick-initialized')) {
            dots: false,
            slider.slick({
                prevArrow: '<button class="icon-prev slick-prev"></button>',
                nextArrow: '<button class="icon-next slick-next"></button>',
                arrows: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                rows: 0,
                adaptiveHeight: true,
                autoplay: true,
                appendArrows: arrowsHolder,
                responsive: [
                {
                    breakpoint: 1023,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll:  1
                    }
                }
                ]
            });
        }
    });

    jQuery('.related-slider').each(function(){
        var slider = jQuery(this);
        var arrowsHolder = slider.closest('.related-slider-wrap').find('.slider-nav');

        if (!slider.hasClass('slick-initialized')) {
            dots: false,
            slider.slick({
                prevArrow: '<button class="icon-prev slick-prev"></button>',
                nextArrow: '<button class="icon-next slick-next"></button>',
                arrows: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                rows: 0,
                adaptiveHeight: true,
                autoplay: true,
                appendArrows: arrowsHolder,
                responsive: [
                {
                    breakpoint: 1023,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll:  1
                    }
                }
                ]
            });
        }
    });

    jQuery('.features-slideshow').slick({
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        rows: 0,
        adaptiveHeight: true,
        responsive: [
        {
            breakpoint: 767,
            settings: "unslick"
        }
        ]
    });

    jQuery('.our-team-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        rows: 0,
        responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 580,
            settings: {
                slidesToShow: 1,
                slidesToScroll:  1
            }
        }
        ]
    });

    jQuery('.investors-slider').slick({
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        rows: 0,
        dots: true,
        adaptiveHeight: true,
        responsive: [
        {
            breakpoint: 767,
            settings: "unslick"
        }
        ]
    });

    jQuery('.toc-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        variableWidth: true,
        infinite: false,
        responsive: [
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        }
        ]
    });

    jQuery('.fabric-member-slider').slick({
        dots: false,
        infinite: true,
        speed: 500,
        autoplaySpeed: 3000,
        rows: 0,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerPadding: '0',
        centerMode: true,
        arrows: false,
        vertical: true,
        verticalSwiping: true,
        focusOnSelect: true,
        autoplay: true,

        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    centerMode: false,
                }
            }
        ]
    });
}

export const initInlineSVG = () => {
    $('.inline-svg').each(function () {
            var img = $(this);
            if (img.length > 0) {
                    $.get(img[0].src, function (svgDoc) {
                            var importedSVGRootElement = document.importNode(svgDoc.documentElement, true);
                            if (img.hasClass('no-fill')) {
                                    img.parent().html(importedSVGRootElement);
                            } else {
                                    img.parent().html(importedSVGRootElement).find('svg').addClass('fill-current');
                            }
                    });
            }
    });
}

export const moveContent = () => {
    var win = jQuery(window);
    var wrapper = jQuery('#wrapper');
    var videoHold = jQuery('.media-06 .video');

    var desktopContent = jQuery('.desktop-content');
    var mobileContent = jQuery('.mobile-content');

    function init() {
        if (wrapper.css('z-index') == 9) {
            mobileContent.append(videoHold);
        } else {
            desktopContent.append(videoHold);
        }
    }

    init()

    win.resize(function() {
        init()
    })
}

export const VideoModal = () => {
    function videoId(button) {
        var $videoUrl = button.attr("data-video");
        if ($videoUrl !== undefined) {
            var $videoUrl = $videoUrl.toString();
            var srcVideo;

            if ($videoUrl.indexOf("youtube") !== -1) {
                var et = $videoUrl.lastIndexOf("&");
                if (et !== -1) {
                    $videoUrl = $videoUrl.substring(0, et);
                }
                var embed = $videoUrl.indexOf("embed");
                if (embed !== -1) {
                    $videoUrl =
                    "https://www.youtube.com/watch?v=" +
                    $videoUrl.substring(embed + 6, embed + 17);
                }

                srcVideo =
                "https://www.youtube.com/embed/" +
                $videoUrl.substring($videoUrl.length - 11, $videoUrl.length) +
                "?autoplay=1&mute=1&loop=1&playlist=" +
                $videoUrl.substring($videoUrl.length - 11, $videoUrl.length) +
                "";
            } else if ($videoUrl.indexOf("youtu") !== -1) {
                var et = $videoUrl.lastIndexOf("&");
                if (et !== -1) {
                    $videoUrl = $videoUrl.substring(0, et);
                }
                var embed = $videoUrl.indexOf("embed");
                if (embed !== -1) {
                    $videoUrl =
                    "https://youtu.be/" +
                    $videoUrl.substring(embed + 6, embed + 17);
                }

                srcVideo =
                "https://www.youtube.com/embed/" +
                $videoUrl.substring($videoUrl.length - 11, $videoUrl.length) +
                "?autoplay=1&mute=1&loop=1&playlist=" +
                $videoUrl.substring($videoUrl.length - 11, $videoUrl.length) +
                "";

            } else if ($videoUrl.indexOf("vimeo") !== -1) {
                srcVideo =
                "https://player.vimeo.com/video/" +
                $videoUrl
                .substring($videoUrl.indexOf(".com") + 5, $videoUrl.length)
                .replace("/", "") +
                "?autoplay=1";


            } else if ($videoUrl.indexOf("mp4") !== -1) {
                return (
                    '<video loop playsinline autoplay controls><source src="' +
                    $videoUrl +
                    '" type="video/mp4"></video>'
                    );
            } else {
                alert(
                    "The video assigned is not from Youtube, Vimeo or MP4, remember to enter the correct complete video link .\n - Youtube: https://www.youtube.com/watch?v=43ngkc2Ejgw\n - Vimeo: https://vimeo.com/111939668\n - MP4 https://server.com/file.mp4"
                    );
                return false;
            }
            return (
                '<iframe src="' +
                srcVideo +
                '" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'
                );
        } else {
            alert("No video assigned.");
            return false;
        }
    }

    $(".play-video").click(function (e) {
        e.preventDefault();
        $("body").append('<div id="video-wrap"></div>');
        var $theVideo = videoId($(this));
        if ($theVideo) {
            $("#video-wrap")
            .html(
                '<span class="video-overlay"></span><div class="video-container"><div class="video-wrap"><div class="video-frame"><button class="close-video"></button>' +
                $theVideo +
                '</div></div></div>'
                )
            .addClass("active");
            $('body').addClass('video-active');
        }
    });

    $(document).on("click", ".close-video, .video-overlay", function () {
        $("#video-wrap").empty().removeClass("active");
        $('body').removeClass('video-active');
        $('#video-wrap').remove();
    });
}

export const Modal = () => {

    $("a[href^='#modal-']").on('click', function () {
        var target = $($(this).attr('href'));
        $('body').addClass('modal-active');
        $('.modal').removeClass('show');
        target.addClass('show');
        return false;
    });

    $('[data-modal]').on('click', function () {
        $('body').addClass('modal-active');
        $('.modal').removeClass('show');
        $($(this).attr('href')).addClass('show');
        return false;
    });

    jQuery('[data-modal-close]').click(function (e) {
        e.preventDefault();
        $('body').removeClass('modal-active');
        $('.modal').removeClass('show');
    });

    jQuery('html').on('click touchstart pointerdown MSPointerDown', function (e) {
        var target = jQuery(e.target);
        if (!target.closest('[data-modal-box]').length) {
            $('[data-modal-box]').parents('.show').removeClass('show');
            $('[data-modal-box].show').removeClass('show');
            $(target).parents('.modal-active').removeClass('modal-active');
        }
    });
}

export const InitFabricSlider = () => {
    const fabric = document.querySelectorAll('.fabric-slider');

    if(fabric) {
        Array.from(fabric).forEach((slide) => {
            new FabricSlider(slide);
        });
    }
}

export const InitFabricOnScroll = () => {
    new FabricOnScroll();
}

export const InitFabricHeroWave = () => {
    const fabricHeroWave = document.getElementById('scene-hero-wave');
    if(fabricHeroWave) {
        new FabricHeroWave();
    }
}

export const Anchor = () => {

    jQuery("a[href^='#anchor-'], .anchor").on('click', function () {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {

            var target = jQuery(this.hash.replace('#anchor-','#'));
            target = target.length ? target : jQuery('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
                var targetOffset = target.offset().top;
                jQuery('html, body').animate({
                    scrollTop: targetOffset - $('header').outerHeight()
                }, 800);

                return false;
            }
        }
    });
}

export const MatchHeight = () => {
    $('.match').matchHeight({});
}

export const initToc = () => {
    const tocDesktop = $('.toc-list--desktop');
    if (tocDesktop.length) {
        let activeNavItem = -1;
        const tocAnchors = $('[data-toc-header]');
        if (tocAnchors.length) {
            tocDesktop.empty();
            tocAnchors.each((i, elem) => {
                const $elem = $(elem);
                const $li = $('<li/>');
                const $anchor = $('<a/>')
                    .attr('href', `#${$elem.attr('id')}`)
                    .text($elem.attr('data-toc-header'));
                if (0 === i) {
                    $anchor.addClass('active');
                }
                $li.append($anchor).appendTo(tocDesktop);
            });

            const $li = $('<li/>');
            const $anchor = $('<a/>')
                .attr('href', `#wrapper`)
                .addClass('go-to')
                .text('Back to top');

            $li.append($anchor).appendTo(tocDesktop);

            $('.toc-list--desktop a').click(function () {
                const parent = $(this).parents('.toc-wrap')
                parent.find('li').removeClass('active');
                $(this).parent().addClass('active');
                if (parent.prev('.select-opener').length) {
                    parent
                        .slideUp(200)
                        .prev().removeClass('active')
                    // activeText()
                }
                var offsetVal = 0;

                setTimeout(() => {
                    if($(window).innerWidth() < 1024) {
                        offsetVal = 300
                    } else {
                        offsetVal = 150
                    }
                    $('html, body').stop().animate({
                        scrollTop: $($(this).attr('href')).offset().top - offsetVal
                    }, 300);
                }, 120);
                return false;
            });

            // function activeText() {
            //     var activeTxt = $('.toc-list--desktop > .active > a').length ? $('.toc-list--desktop > .active > a').text() : $('.toc-list--desktop > li:first-child a').text()
            //     $('.select-opener').text(activeTxt);
            // }

            $(window).scroll(() => {
                const scrollDistance = $(window).scrollTop();
                let activeItem = 0;
                tocAnchors.each(function (i) {
                    if ($(this).position().top - 100 <= scrollDistance) {
                        activeItem = i;
                    }
                });
                if (activeItem !== activeNavItem) {
                    $('.toc-list--desktop').each(function() {
                        $(this).find('.active').removeClass('active')
                        $(this).find('li').eq(activeItem).addClass('active')
                    })
                    activeNavItem = activeItem;
                }
                // activeText()
            }).scroll();

            $('.sticky-aside .toc-list').removeAttr('style');
        }
    }
}

export const MaxCharacter = () => {
    $('.max-character > *').text(function(index, currentText) {
        var maxLength = $(this).parent().attr('data-maxlength');
        if(currentText.length >= maxLength) {
            return currentText.substr(0, maxLength) + "...";
        } else {
            return currentText
        }
    });
}

export const SearchOpener = () => {
    $('.search-opener').click(function (e) {
        e.preventDefault();
        $('body').toggleClass('search-active');
        $(window).scrollTop(0);
    });
}